import { withStyles } from "@material-ui/core";
import KPISubGroup from "./KPISubGroup";
import React from "react";
import KPIGroupHeader from "./KPIGroupHeader";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    "&:not(:last-of-type)": {
      borderRight: `1px solid ${theme.AppBGColor}`,
    },
    "&:first-child": {
      padding: "1 24 0 0",
    },
    "&:not(:first-child)": {
      padding: "1 24 0 0",
    },
  },
  kpiValueContainer: {
    display: "flex",
  },
});

const KPIGroup = ({ classes, kpiGroupData, index }) => {
  const { kpiGroup, suffix } = kpiGroupData;
  return (
    <div className={classes.container} key={`kpiGroup-${index}`}>
      <KPIGroupHeader kpiGroup={kpiGroup} suffix={suffix} />
      <div className={classes.kpiValueContainer}>
        {kpiGroupData.kpis.map((subGroup, index) => (
          <KPISubGroup
            key={subGroup.kpiName}
            subGroupData={subGroup}
            kpiGroupData={kpiGroupData.data}
            groupIndex={index}
          />
        ))}
      </div>
    </div>
  );
};
export default withStyles(styles)(KPIGroup);
